import { useState, useEffect } from 'react';

interface ShopInfo {
    shop_name: string;
    logo_url?: string;
    currency?: string;
}

export function useShopSettings() {
    const [shopInfo, setShopInfo] = useState<ShopInfo | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                // Since this is admin panel, we can use admin route which is protected
                // but public /api/settings/shop_info is also available and faster potentially?
                // Let's use public for layout as it's less critical.
                // NO, use admin route to be consistent with auth context if possible, 
                // but public route works fine for shop name.
                // However, let's use /api/settings/shop_info to avoid 401 if token issues on first render
                // But wait, layout is protected by AuthGuard. So we have token (in cookie).
                // Let's use /api/admin/settings/shop_info as it is the source of truth handled by admin.

                const res = await fetch('/api/admin/settings/shop_info');
                if (res.ok) {
                    const data = await res.json();
                    if (data.success && data.data) {
                        setShopInfo(data.data as ShopInfo);
                    }
                }
            } catch (error) {
                console.error('Failed to fetch shop settings:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchSettings();
    }, []);

    return { shopInfo, loading };
}
